import API from './API';

export default class Analytics extends API {

  static get() {
    return super.get(`/analytics`);
  }

}



// WEBPACK FOOTER //
// ./src/services/api/Analytics.js